'use client';
import { useEffect } from 'react';

const useCaptcha = (submit: (token: string) => void) => {
  useEffect(() => {
    const loadScriptByURL = (id: string, url: string, callback: any) => {
      const isScriptExist = document.getElementById(id);
      if (!isScriptExist) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) {
            callback();
          }
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) {
        callback();
      }
    };
    loadScriptByURL('recaptcha-key', `https://www.google.com/recaptcha/api.js?render=${process.env.GOOGLE_RECAPTCHA_V3_SITE_KEY}`, function () {
    });
  }, []);

  const handleReCaptchaVerify = () => {
    // e.preventDefault();
    // @ts-ignore
    window?.grecaptcha.ready(() => {
      // @ts-ignore
      window?.grecaptcha.execute(process.env.GOOGLE_RECAPTCHA_V3_SITE_KEY, { action: 'submit' }).then((token: string) => {
        submit(token);
      });
    });
  };

  return { handleReCaptchaVerify };
};

export default useCaptcha;
